export const countryCurrencyCodes = [
    { country: "New Zealand Dollar", code: "NZD"},
    { country: "Australian Dollar", code: "AUD"},
    { country: "European Euro", code: "EUR"},
    { country: "United States Dollar", code: "USD"},
    { country: "Japanese Yen", code: "JPY"},
    { country: "Canadian Dollar", code: "CAD"},
    { country: "United Arab Emirates Dirham", code: "AED"},
    { country: "Afghan Afghani", code: "AFN"},
    { country: "Albanian Lek", code: "ALL"},
    { country: "Armenian Dram", code: "AMD"},
    { country: "Netherlands Antillean Guilder", code: "ANG"},
    { country: "Angolan Kwanza", code: "AOA"},
    { country: "Argentine Peso", code: "ARS"},
    { country: "Aruban Florin", code: "AWG"},
    { country: "Azerbaijani Manat", code: "AZN"},
    { country: "Azerbaijani Manat", code: "AZN"},
    { country: "Bosnia-Herzegovina Convertible Mark", code: "BAM"},
    { country: "Barbadian Dollar", code: "BBD"},
    { country: "Bangladeshi Taka", code: "BDT"},
    { country: "Bulgarian Lev", code: "BGN"},
    { country: "Bahraini Dinar", code: "BHD"},
    { country: "Burundian Franc", code: "BIF"},
    { country: "Bermudan Dollar", code: "BMD"},
    { country: "Brunei Dollar", code: "BND"},
]
